import { useMutation, UseMutationResult } from 'react-query';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseMutationMyTripGuestLoginData = Content.Endpoints.MyTripGuestLogin;

interface UseMutationMyTripGuestLoginError {
  errors: any;
  message?: string;
}

interface UseMutationMyTripGuestLoginParameters {
  parameters: {
    bookingNo: string;
    password: string;
  };
}

const useMutationMyTripGuestLogin = () => {
  const locale = getLocale();

  const mutation: UseMutationResult<
    UseMutationMyTripGuestLoginData,
    UseMutationMyTripGuestLoginError,
    UseMutationMyTripGuestLoginParameters
  > = useMutation(
    async variables => {
      const fetchResponse = await fetch('/api/users/my-trip-guest-login', {
        body: JSON.stringify({
          bookingNo: variables.parameters.bookingNo,
          password: variables.parameters.password,
        }),
        headers: {
          ['Accept-Language']: getCulture(locale),
          ['Content-Type']: 'application/json',
        },
        method: 'POST',
      })
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('content.useMutationMyTripGuestLogin', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      onError: async error => error,
    },
  );

  return mutation;
};

export default useMutationMyTripGuestLogin;
